import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import {thunk} from 'redux-thunk';
import rootReducer from '../reducers/index';

const configureStore = (initialState) => {
	return createStore(
		rootReducer,
		initialState,
		applyMiddleware(thunk)
	)
}
export const dataStore = configureStore();
export default configureStore;